function initBlogArticle() {
  document.querySelectorAll('[class*="blog-article-"] .ba-share-btn').forEach((btn) => {
    if (btn.dataset.baInit) return;
    btn.dataset.baInit = 'true';

    if (btn.getAttribute('target') === '_blank') {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        window.open(btn.href, 'share', 'width=600,height=500,noopener,noreferrer');
      });
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlogArticle);
} else {
  initBlogArticle();
}

document.addEventListener('shopify:section:load', initBlogArticle);